import microuniversoApi from "app/api/microuniversoApi";
import { atualizarItemAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { IItemOrcamento } from "../../types/IItemOrcamento";

declare var window: any

export type AlterarMostruarioParams = {
    item: IItemOrcamento,
    check: boolean
}

export type AlterarMostruarioOutput = {
    status: "SUCESSO" | "ERRO"
}

// PA 487087 - o blockUI/unblockUI fica a cargo do container chamador
// (EditarItemContainer/ItensOrcamentoContainer), como nos demais handlers de item.
// Bloquear aqui tambem causava block/unblock duplo (aninhado) por clique.
export async function alterarMostruarioItem(params: AlterarMostruarioParams): Promise<AlterarMostruarioOutput> {
    const orcamentoAtualizado = await microuniversoApi.Orcamento.definirMostruarioItemOrcamento(
        store.getState().orcamento.IdentificadorOrcamento,
        params.item.Identificador,
        params.check
    )

    if (orcamentoAtualizado == null) return { status: "ERRO" }

    const orcamentoLegado = window.orcamentoController.model
    orcamentoLegado.atualizar(orcamentoAtualizado)

    store.dispatch(atualizarItemAction({
        identificador: params.item.Identificador,
        dados: { Mostruario: params.check }
    }))

    return {
        status: "HasErrors" in orcamentoAtualizado ? "ERRO" : "SUCESSO"
    }
}